import { Outlet } from "react-router-dom";

function ShopLayout (){
    return (
        <div>
            <Outlet/>
        </div>
        
    )
}
export default ShopLayout